import LoadingView from './LoadingView';
export default LoadingView;
